import { render, staticRenderFns } from "./img-link.vue?vue&type=template&id=2ed17f9f&scoped=true&"
import script from "./img-link.vue?vue&type=script&lang=js&"
export * from "./img-link.vue?vue&type=script&lang=js&"
import style0 from "./img-link.vue?vue&type=style&index=0&id=2ed17f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed17f9f",
  null
  
)

export default component.exports